import AppRoutes from "./routes/AppRoutes";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useLocation } from "react-router-dom";
import { Toaster } from 'react-hot-toast';

function App() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/";
  return (
    <div>
      {!hideNavbar && <Navbar />}
      <Toaster position="top-right" />
      <main >
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

export default App;


